const styles = theme => ({
    root: {
        textAlign: 'center',
        marginTop: '25%'
    },
    inner: {
        padding: theme.spacing(4),
        margin: theme.spacing(8),
        borderColor: theme.palette.common.border || 'gainsboro',
        borderWidth: 1,
        borderStyle: 'solid',
        color: theme.palette.text.primary

    }
});

export default styles;